var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "layout-panel" }, [
    _c("div", { staticClass: "panel-header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "dbh-btn dbh-btn--outline",
          on: { click: _vm.addFixture },
        },
        [_c("i", { staticClass: "bi bi-plus" }), _vm._v(" Fixture\n    ")]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "panel-subtitle" }, [
      _vm._v(
        "\n    Ordered left to right to match the canvas. Hover a fixture to reorder or remove.\n  "
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "fixtures-list" },
      [
        _c(
          "transition-group",
          {
            staticStyle: { display: "contents" },
            attrs: { name: "fixture", tag: "div" },
          },
          [
            _vm._l(_vm.fixtures, function (fixture, index) {
              return _c(
                "div",
                {
                  key: fixture.id,
                  staticClass: "fixture-card",
                  attrs: { "data-layout-fixture-key": fixture.key },
                },
                [
                  _c("div", { staticClass: "fixture-name-row" }, [
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "b-toggle",
                            rawName: "v-b-toggle",
                            value: `fixture-collapse-${fixture.id}`,
                            expression: "`fixture-collapse-${fixture.id}`",
                          },
                        ],
                        staticClass: "fixture-collapse-toggle",
                        attrs: { type: "button", title: "Expand / Collapse" },
                      },
                      [_c("i", { staticClass: "bi bi-chevron-right" })]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: fixture.name,
                          expression: "fixture.name",
                        },
                      ],
                      staticClass: "fixture-name-input",
                      attrs: { placeholder: "Fixture " + (index + 1) },
                      domProps: { value: fixture.name },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(fixture, "name", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn-move-fixture",
                        attrs: { title: "Move Left", disabled: index === 0 },
                        on: {
                          click: function ($event) {
                            return _vm.moveLeft(index)
                          },
                        },
                      },
                      [_c("i", { staticClass: "bi bi-chevron-up" })]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn-move-fixture",
                        attrs: {
                          title: "Move Right",
                          disabled: index === _vm.fixtures.length - 1,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.moveRight(index)
                          },
                        },
                      },
                      [_c("i", { staticClass: "bi bi-chevron-down" })]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn-remove-fixture",
                        attrs: { title: "Remove" },
                        on: {
                          click: function ($event) {
                            return _vm.removeFixture(index)
                          },
                        },
                      },
                      [_c("i", { staticClass: "bi bi-trash" })]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      attrs: {
                        id: `fixture-collapse-${fixture.id}`,
                        visible: "",
                      },
                    },
                    [
                      _c("div", { staticClass: "fixture-fields" }, [
                        _c("div", { staticClass: "field-item" }, [
                          _c("span", { staticClass: "field-label" }, [
                            _vm._v("Left %"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.number",
                                value: fixture.left,
                                expression: "fixture.left",
                                modifiers: { number: true },
                              },
                            ],
                            staticClass: "field-input",
                            attrs: { type: "number", step: "0.1" },
                            domProps: { value: fixture.left },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  fixture,
                                  "left",
                                  _vm._n($event.target.value)
                                )
                              },
                              blur: function ($event) {
                                return _vm.$forceUpdate()
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "field-item" }, [
                          _c("span", { staticClass: "field-label" }, [
                            _vm._v("Width %"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.number",
                                value: fixture.width,
                                expression: "fixture.width",
                                modifiers: { number: true },
                              },
                            ],
                            staticClass: "field-input",
                            attrs: { type: "number", step: "0.1" },
                            domProps: { value: fixture.width },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  fixture,
                                  "width",
                                  _vm._n($event.target.value)
                                )
                              },
                              blur: function ($event) {
                                return _vm.$forceUpdate()
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "field-item" }, [
                          _c("span", { staticClass: "field-label" }, [
                            _vm._v("Top %"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.number",
                                value: fixture.top,
                                expression: "fixture.top",
                                modifiers: { number: true },
                              },
                            ],
                            staticClass: "field-input",
                            attrs: { type: "number", step: "0.1" },
                            domProps: { value: fixture.top },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  fixture,
                                  "top",
                                  _vm._n($event.target.value)
                                )
                              },
                              blur: function ($event) {
                                return _vm.$forceUpdate()
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "field-item" }, [
                          _c("span", { staticClass: "field-label" }, [
                            _vm._v("Bottom %"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.number",
                                value: fixture.bottom,
                                expression: "fixture.bottom",
                                modifiers: { number: true },
                              },
                            ],
                            staticClass: "field-input",
                            attrs: { type: "number", step: "0.1" },
                            domProps: { value: fixture.bottom },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  fixture,
                                  "bottom",
                                  _vm._n($event.target.value)
                                )
                              },
                              blur: function ($event) {
                                return _vm.$forceUpdate()
                              },
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "shelves-row" }, [
                        _c("div", { staticClass: "shelves-control" }, [
                          _c("span", { staticClass: "shelves-label" }, [
                            _vm._v("Shelves"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "shelf-btn",
                              on: {
                                click: function ($event) {
                                  return _vm.decrementShelves(fixture)
                                },
                              },
                            },
                            [_vm._v("\n                −\n              ")]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "shelf-count" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(fixture.shelves) +
                                "\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "shelf-btn",
                              on: {
                                click: function ($event) {
                                  return _vm.incrementShelves(fixture)
                                },
                              },
                            },
                            [_vm._v("\n                +\n              ")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn-reset",
                            on: {
                              click: function ($event) {
                                return _vm.resetFixture(fixture, index)
                              },
                            },
                          },
                          [_vm._v("\n              Reset\n            ")]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "perspective-control" }, [
                        _c(
                          "div",
                          { staticClass: "perspective-control__label" },
                          [
                            _c("span", [_vm._v("Angle")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.formatDegrees(fixture.angle))),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "range-row" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.number",
                                value: fixture.angle,
                                expression: "fixture.angle",
                                modifiers: { number: true },
                              },
                            ],
                            staticClass: "fine-tune-range",
                            attrs: {
                              type: "range",
                              min: _vm.MIN_FIXTURE_ANGLE,
                              max: _vm.MAX_FIXTURE_ANGLE,
                              step: "0.5",
                            },
                            domProps: { value: fixture.angle },
                            on: {
                              input: function ($event) {
                                return _vm.setFixtureAngle(fixture)
                              },
                              __r: function ($event) {
                                _vm.$set(
                                  fixture,
                                  "angle",
                                  _vm._n($event.target.value)
                                )
                              },
                              blur: function ($event) {
                                return _vm.$forceUpdate()
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "range-end-label" }, [
                            _vm._v("Flat"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "corners-row" }, [
                          _c("span", [_vm._v("Corners")]),
                          _vm._v(" "),
                          _c("span", { staticClass: "corners-status" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  fixture.isCustomPerspective
                                    ? "Custom perspective"
                                    : "Angle perspective"
                                ) +
                                "\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "inline-reset",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.resetFixtureCorners(fixture)
                                },
                              },
                            },
                            [_vm._v("\n                Reset\n              ")]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      fixture.shelfFineTuning.length
                        ? _c(
                            "div",
                            { staticClass: "shelf-fine-tuning" },
                            [
                              _c(
                                "div",
                                { staticClass: "shelf-fine-tuning__title" },
                                [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "b-toggle",
                                          rawName: "v-b-toggle",
                                          value: `shelf-tuning-${fixture.id}`,
                                          expression:
                                            "`shelf-tuning-${fixture.id}`",
                                        },
                                      ],
                                      staticClass:
                                        "shelf-fine-tuning__title-text",
                                    },
                                    [
                                      _vm._v(
                                        "\n                Shelf fine-tuning\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      directives: [
                                        {
                                          name: "b-toggle",
                                          rawName: "v-b-toggle",
                                          value: `shelf-tuning-${fixture.id}`,
                                          expression:
                                            "`shelf-tuning-${fixture.id}`",
                                        },
                                      ],
                                      staticClass: "fixture-collapse-toggle",
                                      attrs: {
                                        type: "button",
                                        title: "Expand / Collapse",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "bi bi-chevron-right",
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-collapse",
                                {
                                  attrs: {
                                    id: `shelf-tuning-${fixture.id}`,
                                    visible: "",
                                  },
                                },
                                _vm._l(
                                  fixture.shelfFineTuning,
                                  function (shelf, shelfIndex) {
                                    return _c(
                                      "div",
                                      {
                                        key: shelf.id || shelfIndex,
                                        staticClass: "shelf-tuning-row",
                                        attrs: {
                                          "data-layout-shelf-id": shelf.id,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center",
                                          },
                                          [
                                            _c(
                                              "strong",
                                              { staticClass: "mr-auto" },
                                              [
                                                _vm._v(
                                                  "Shelf " +
                                                    _vm._s(shelfIndex + 1)
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass: "btn-move-fixture",
                                                attrs: {
                                                  type: "button",
                                                  title: "Move shelf up",
                                                  "aria-label": "Move shelf up",
                                                  disabled: shelfIndex === 0,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.$emit(
                                                      "move-shelf",
                                                      {
                                                        fixtureKey: fixture.key,
                                                        shelfId: shelf.id,
                                                        direction: -1,
                                                      }
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "bi bi-chevron-up",
                                                }),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass: "btn-move-fixture",
                                                attrs: {
                                                  type: "button",
                                                  title: "Move shelf down",
                                                  "aria-label":
                                                    "Move shelf down",
                                                  disabled:
                                                    shelfIndex ===
                                                    fixture.shelfFineTuning
                                                      .length -
                                                      1,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.$emit(
                                                      "move-shelf",
                                                      {
                                                        fixtureKey: fixture.key,
                                                        shelfId: shelf.id,
                                                        direction: 1,
                                                      }
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "bi bi-chevron-down",
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "shelf-tuning-control",
                                          },
                                          [
                                            _c("span", [_vm._v("Y pos")]),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model.number",
                                                  value: shelf.yOffset,
                                                  expression: "shelf.yOffset",
                                                  modifiers: { number: true },
                                                },
                                              ],
                                              staticClass: "fine-tune-range",
                                              attrs: {
                                                type: "range",
                                                min: _vm.MIN_SHELF_Y_OFFSET,
                                                max: _vm.MAX_SHELF_Y_OFFSET,
                                                step: "0.5",
                                              },
                                              domProps: {
                                                value: shelf.yOffset,
                                              },
                                              on: {
                                                __r: function ($event) {
                                                  _vm.$set(
                                                    shelf,
                                                    "yOffset",
                                                    _vm._n($event.target.value)
                                                  )
                                                },
                                                blur: function ($event) {
                                                  return _vm.$forceUpdate()
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "fine-tune-value",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatNumber(
                                                      shelf.yOffset
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass: "inline-reset",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    shelf.yOffset = 0
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Reset\n                  "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "shelf-tuning-control",
                                          },
                                          [
                                            _c("span", [_vm._v("Height")]),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model.number",
                                                  value: shelf.heightPercent,
                                                  expression:
                                                    "shelf.heightPercent",
                                                  modifiers: { number: true },
                                                },
                                              ],
                                              staticClass: "fine-tune-range",
                                              attrs: {
                                                type: "range",
                                                min: _vm.MIN_SHELF_AREA_HEIGHT_PERCENT,
                                                max: _vm.getShelfHeightMaxPercent(
                                                  shelf
                                                ),
                                                step: "0.5",
                                              },
                                              domProps: {
                                                value: shelf.heightPercent,
                                              },
                                              on: {
                                                __r: function ($event) {
                                                  _vm.$set(
                                                    shelf,
                                                    "heightPercent",
                                                    _vm._n($event.target.value)
                                                  )
                                                },
                                                blur: function ($event) {
                                                  return _vm.$forceUpdate()
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "fine-tune-value",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatPercent(
                                                      shelf.heightPercent
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass: "inline-reset",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.resetShelfHeight(
                                                      fixture,
                                                      shelf
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Reset\n                  "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "shelf-tuning-control",
                                          },
                                          [
                                            _c("span", [_vm._v("Skew")]),
                                            _vm._v(" "),
                                            _c("input", {
                                              staticClass: "fine-tune-range",
                                              attrs: {
                                                type: "range",
                                                min: _vm.MIN_SHELF_SKEW,
                                                max: _vm.MAX_SHELF_SKEW,
                                                step: "0.5",
                                              },
                                              domProps: {
                                                value:
                                                  _vm.getShelfEffectiveAngle(
                                                    fixture,
                                                    shelf
                                                  ),
                                              },
                                              on: {
                                                input: function ($event) {
                                                  return _vm.setShelfEffectiveAngle(
                                                    fixture,
                                                    shelf,
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "fine-tune-value",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatDegrees(
                                                      _vm.getShelfEffectiveAngle(
                                                        fixture,
                                                        shelf
                                                      )
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass: "inline-reset",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    shelf.skew = 0
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Reset\n                  "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              )
            }),
            _vm._v(" "),
            _vm.fixtures.length === 0
              ? _c("div", { key: "empty", staticClass: "empty-state" }, [
                  _c("i", { staticClass: "bi bi-layout-three-columns" }),
                  _vm._v("\n        No fixtures yet. Click "),
                  _c("strong", [_vm._v("+ Fixture")]),
                  _vm._v(" to add one.\n      "),
                ])
              : _vm._e(),
          ],
          2
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "panel-footer" }, [
      _c(
        "button",
        { staticClass: "btn-restore", on: { click: _vm.restoreDefaults } },
        [_vm._v("\n      Restore defaults\n    ")]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "panel-title" }, [
      _c("span", { staticClass: "title-icon" }, [
        _c("i", { staticClass: "bi bi-grid-1x2" }),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("Layout")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }